import Vue from 'vue';
import router from '@/router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store';
import {
	checkToken
} from '@/utils/request';
import {
	baseRouterList
} from '@/router/base';
import {
	routerList
} from "@/router/custom";
import {
	i18nRender
} from "@/locales";
import {
	permissions
} from "@/api/app";

function fetchPaths(routerList, pathList = []) {
	routerList.forEach(item => {
		pathList.push(item.path);

		if (item.children !== undefined) {
			fetchPaths(item.children, pathList);
		}
	});

	return pathList;
}

/* function fetchPaths(routerList) {
	let pathList = [];
	routerList.forEach(item => {
		pathList.push(item.path);

		if (item.children !== undefined) {
			fetchPaths(item.children, pathList);
		}
	});

	return pathList;
} */

NProgress.configure({
	showSpinner: false
});

// 登录路由
const loginPath = '/login';

// 首页
// const homePath = '/workplace';

// 默认权限列表，即每个用户都有的权限
const allowList = ['/403', '/Exp500', '/workplace', '/setting'];

// 路由跳转前拦截
router.beforeEach((to, from, next) => {
	NProgress.start();
	// 设置标题
	let pageTitle = (to.meta && to.meta.title) ? i18nRender(to.meta.title) : to.name;
	document.title = pageTitle + ' - Boss Admin';

	if (to.path == loginPath) {
		next();
	} else {
		if (checkToken()) {
			// 管理员权限
			if (store.state.admin.permissions.length == 0) {
				permissions().then(res => {
					console.log('res', res);
					let permissionList = [];
					if (store.state.setting.isDynamicRoute) { // 动态权限
						permissionList = res.data.permissions;
					} else { // 静态权限
						permissionList = fetchPaths(routerList);
					}

					permissionList = allowList.concat(permissionList);
					// console.log(permissionList, '现有权限')
					store.commit('admin/setPermissions', permissionList);

					const userRouterList = routerList.filter((item) => {
						if (permissionList.includes(item.path)) {
							if (item.children && item.children.length > 0) {
								let subList = item.children.filter((subItem) => {
									if (permissionList.includes(subItem.path)) {
										return subItem;
									}
								});

								if (subList && subList.length > 0) {
									item.children = subList;
								}
							}
							return item;
						}
					});

					// 保存菜单
					store.commit('admin/setMenus', userRouterList);
					const allRouterList = baseRouterList.filter((item) => {
						if (item.path == '/') {
							item.children = item.children.concat(userRouterList);
							return item;
						} else {
							return item;
						}
					});

					// 将新路由列表添加到路由器
					router.$addRoutes(allRouterList);

					// 必须用{...to, replace:true}，不然刷新变空白
					next({
						...to,
						replace: true
					});
				});
			} else {
				next();
			}

		} else {
			next({
				path: loginPath
			});
		}
	}

});

router.afterEach(() => {
	NProgress.done();
});

// 注册全局指令 v-has 用于完成按钮级权限判断
Vue.directive('has', {
	inserted: (el, binding) => {
		const value = binding.value;
		
		// console.log(store.state.admin.permissions);
		if (!store.state.admin.permissions.includes(value)) {
			// 将按钮置为不可用
			if (el.tagName == 'a' || el.tagName == 'A') {
				let elSpan = document.createElement("span");
				elSpan.innerHTML = el.innerHTML;
				elSpan.setAttribute('style', 'cursor: not-allowed;color:#d3d3d3');
				el.parentNode.replaceChild(elSpan, el);
			} else {
				let elButton = document.createElement("button");
				elButton.innerHTML = el.innerHTML;
				elButton.className = 'disabled-button';
				el.parentNode.replaceChild(elButton, el);
			}
		}
	}
});